module.exports = __webpack_public_path__ + "static/media/panic_buying_btn.png";